import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParsedDateTimePipe } from './parsed-date-time.pipe';

@NgModule({
  declarations: [ParsedDateTimePipe],
  imports: [CommonModule],
  exports: [ParsedDateTimePipe],
})
export class ParsedDateTimeModule {}
